/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  "jquery",
  "pip-model",
  "pip-events",
  "cookie-utils",
  "mustache"
], function($, pip, pipEvents, cookieUtils, Mustache) {
  var m = {};

  m.init = function init(renderDesktop) {
    if (pip.platform === "MOBILE") {
      setStarWidths();
      setStars();
    } else if (!pip.features.ugcZoneAReact || renderDesktop === true) {
      m.loadUserToken();
    }
  };

  m.loadUserToken = function loadUserToken() {
    if (
      cookieUtils.readCookie("THD_USERSTATUS") === "1" &&
      cookieUtils.getUserIdFromUserActivityCookie() !== -1002
    ) {
      $.ajax({
        url: "/p/svcs/getEncodedUserToken",
        cache: false,
        dataType: "json"
      }).always(loadBazaarvoiceApi);
    } else {
      loadBazaarvoiceApi();
    }
  };

  function loadBazaarvoiceApi(data) {
    var bvConfig = {
      allowSamePageSubmission: true,
      productId: pip.products.primary.data.itemId,
      submissionUI: "LIGHTBOX"
    };

    if (data && data.encodedUserToken) {
      bvConfig.userToken = data.encodedUserToken;
    }

    function setupView() {
      // GLOBAL -- $BV
      window.$BV.configure("global", bvConfig);
      if (!pip.features.ugcZoneAReact) {
        window.$BV.ui("rr", "show_reviews", {
          onEvent: function(json) {
            if (json.eventSource == "Display" && json.eType == "Read") {
              updateRatingsData(json);
            }
          }
        });
      }
      window.$BV.ui("qa", "show_questions", {
        subjectType: "product"
      });
    }
    if (window.$BV) {
      setupView();
    } else {
      $.ajax({
        url: pip.features.bazaarVoiceFrontEnd.bvapiUrl,
        cache: true,
        dataType: "script",
        success: function() {
          $($BV.docReady);
          setupView();
        }
      });
    }
  }

  function updateUserTokenInBV() {
    // GLOBAL -- userToken - does this come from BV?
    if (
      typeof window.userToken != undefined &&
      window.userToken !== "" &&
      window.userToken !== null &&
      window.userToken !== "030c7bb021407bc7279d1b1e491def992d31303032"
    ) {
      $.each($(".BVRRRootElement a[data-bvjsref][name]"), function(index, obj) {
        var BVRefLink = $(obj);
        var BVRefLinkHref = BVRefLink.data("bvjsref");
        if (BVRefLinkHref.toLowerCase().indexOf("writereview") > -1) {
          BVRefLinkHref = BVRefLinkHref.replace(
            utilsURL.get({
              url: BVRefLinkHref,
              lookupParm: "user"
            }),
            window.userToken
          );

          BVRefLink.attr("data-bvjsref", BVRefLinkHref);
        }
      });
    }
  }

  function updateRatingsData(data) {
    pip.products.primary.data.ratingsReviews = {
      totalReviews: data.attributes.numReviews,
      averageRating: data.attributes.avgRating
    };
    pipEvents.bazaarVoice.bazaarVoiceRatingsReviewLoaded.trigger();
  }

  function setStarWidths() {
    var starEl = $(".customer-reviews .reviews .stars");
    var rating = starEl.attr("rel");
    starEl.width((rating / 5) * 100 + "%");
  }

  //This is all kinds of Jquery hackery just to make stars show up at the top of the page
  //THIS IS FINE (for now) until we redo BV completely
  function setStars() {
    var template =
      '<div class="mobile-star-ratings"><a href="{{url}}">{{{stars}}} <span>({{reviewCount}})</span></a></div>';
    var markup = Mustache.render(template, {
      url: $("#customer_reviews .card__body").attr("data-url"),
      stars: $(".customer-reviews .reviews")
        .wrap("<div/>")
        .parent()
        .html(),
      reviewCount: $(".customer-reviews__count span").text()
    });
    $(".product-title__review-snippet").replaceWith(markup);
  }

  return m;
});

}.call(window));